import { BoxV2 as Box, Flex } from 'portal-commons';
import { FC } from 'react';

interface TitleProps {
  note?: string;
}

const Title: FC<TitleProps> = ({ note, children }) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xxs',
      color: 't.black90',
      fontWeight: 600,
      fontSize: 'H700',
      lineHeight: 'normal',
    }}
  >
    {children}
    {note && (
      <Box sx={{ color: 't.black70', fontWeight: 400, fontSize: 'H400' }}>
        {note}
      </Box>
    )}
  </Flex>
);

export default Title;
